import { useState, useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import axiosConfig from 'utils/axiosConfig'
import { Box, Typography, Paper, Grid, Button, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions } from '@material-ui/core'
import { Alert } from '@material-ui/lab'
import ResponsiveLayout from 'containers/Layouts/ResponsiveLayout'
import QuestionItem from './Presentation/QuestionItem'
import TimedExamination from './TimedExamination/TimedExamination'

const StudentExamForm = (props) => {
  const examid = props.match.params.exam
  const history = useHistory()

  const [exam, setExam] = useState({})
  const [page, setPage] = useState({})
  const [progress, setProgress] = useState({})

  const [questions, setQuestions] = useState([])
  const [answers, setAnswers] = useState([])
  const [showError, setShowError] = useState(false)
  const [showConfirmationModal, setShowConfirmationModal] = useState(false)

  const getExamination = () => {
    axiosConfig.get(`student-examinations/${examid}`)
      .then((response) => {
        const responseData = response.data

        if (!responseData.success) {
          return
        }

        setExam(responseData.examination)
        setPage(responseData.page)
        setProgress(responseData.progress);
        setQuestions(responseData.questions)
      })
  }

  const closeConfirmationModal = () => {
    setShowConfirmationModal(false)
  }

  const addAnswer = (questionId, answer) => {
    if (answer === undefined) return

    let newAnswers = answers.filter((a) => a.id !== questionId)

    setAnswers([...newAnswers, {
      id: questionId,
      answer: answer
    }])
  }

  const showConfirmSubmitAnswer = () => {
    setShowConfirmationModal(true)
  }

  const submitAnswers = () => {
    axiosConfig.post(`/student-examinations/${examid}`, {
      answers
    }).then((response) => {
      const responseData = response.data

      if (!responseData.success) {
        if (responseData.error !== undefined) {
          setShowError(responseData.message)
        }

        return
      }

      history.push(`/examinations/${examid}/attempts`)
    })
  }

  useEffect(() => {
    getExamination()
  }, [])

  return (
    <ResponsiveLayout>
      <Grid item lg={8} md={8} style={{margin: '0 auto'}}>
        <Paper style={{marginBottom: '20px'}}>

          <Box padding={3} display="flex">
            <Box flexGrow={1}>
              <Typography variant="h6">{exam.name}</Typography>
              <Typography variant="subtitle1">{exam.description}</Typography>
              <Box paddingTop={1} display="flex" whiteSpace={2} gridGap={30}>
                <Box>
                  <Typography color="primary">
                    <i className="fa fa-user"></i> {exam.author?.name}
                  </Typography>
                </Box>
                <Box>
                  <Typography color="primary">
                    <i className="fa fa-star"></i> {exam?.totalPoints} points
                  </Typography>
                </Box>
                {exam?.time_enabled === 1 && page !== undefined &&
                  <Box>
                    <Typography color="primary">
                      <i className="fa fa-question-circle"></i> {progress?.answeredQuestions}/{progress?.totalQuestions} answered questions
                    </Typography>
                  </Box>
                }
              </Box>
            </Box>
            {exam?.time_enabled === 1 && page !== undefined &&
              <Box display="flex" alignItems="center" justifyContent="center" flexDirection="column">
                <Typography variant="h4" color="primary">
                  {page?.currentPage} / {page?.totalPages}
                </Typography>
                <Typography variant="subtitle1" color="primary">
                  Pages
                </Typography>
              </Box>
            }
          </Box>

        </Paper>
        <Dialog
          open={showConfirmationModal}
          onClose={closeConfirmationModal}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">{"Are you sure you want to submit your answers?"}</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              This action will lock-in all your answers. Please double check your answers and make sure all questions are answered.
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={closeConfirmationModal} color="primary">
              Cancel
            </Button>
            <Button onClick={submitAnswers} color="primary" autoFocus>
              Submit Answers
            </Button>
          </DialogActions>
        </Dialog>

        {exam?.time_enabled === 1 &&
          <TimedExamination
            getExamination={getExamination}
            examination={exam}
            page={page}
            updatePage={setPage}
            updateProgress={setProgress}
          />
        }

        {exam?.time_enabled === 0 &&
          <>
            {questions?.length > 0 && questions.map((question) => (
              <QuestionItem question={question} onAnswerSelect={addAnswer} />
            ))}

            {showError !== false &&
              <Box marginBottom={3}>
                <Alert severity="error">{showError}</Alert>
              </Box>
            }

            <Box display="flex" justifyContent="flex-end">
              <Button onClick={showConfirmSubmitAnswer} variant="contained" color="primary">
                Submit Answers
              </Button>
            </Box>
          </>
        }
      </Grid>
    </ResponsiveLayout>
  )
}

export default StudentExamForm